import { DashboardMenu } from "../../data/menu"
import BreadCrump from "../tools/breadcrump"
import { getCookies } from "cookies-next";
import { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import changeUrl from "../../hoc/changeur";
import { config } from "../../data/config";
import { useTranslation } from 'react-i18next';
import HeaderOfPage from "../tools/headerOfPage";
import ImageUploader from '../tools/uploaderImage';

export default function CampaignProductsList() {
    const { t } = useTranslation();

    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Campaign',
            url: '/dashboard/Campaign'
        },
        {
            name: 'لیست محصولات کمپین',
            url: null
        },
    ]
    const reloadgame = () => {
        let x = key + 1;
        setKey(x);
    }
    const [key, setKey] = useState(1);

    return (
        <>
            <div className="text-left bg-white p-3 m-4 h-[100vh] mb-5">
                <BreadCrump data={breadcrump}></BreadCrump>
                <HeaderOfPage name="لیست محصولات کمپین"></HeaderOfPage>

                <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
                    <div className="col-span-1 directions">
                        <NewCampaignProduct reloaditem={reloadgame} key={key}></NewCampaignProduct>
                    </div>
                    <div className="col-span-3 directions">
                        <ListofCampaignProducts key={key}></ListofCampaignProducts>
                    </div>
                </div>
            </div>
        </>
    )
}

function NewCampaignProduct({ reloaditem }: { reloaditem: () => void }) {
    const { t } = useTranslation();
    let cookie = getCookies();
    const [activeLang, setActiveLang] = useState<string>('en');
    const [data, setData] = useState<any>({
        name: { ku: '', fa: '', en: '', ar: '', tr: '' },
        description: { ku: '', fa: '', en: '', ar: '', tr: '' },
        url: { ku: '', fa: '', en: '', ar: '', tr: '' },
        mainprice: null
    });
    const [saving, setSaving] = useState<boolean>(false);
    const [createdProductId, setCreatedProductId] = useState<string | null>(null);

    const languages = [
        { code: 'ku', label: 'Kurdish' },
        { code: 'fa', label: 'فارسی' },
        { code: 'en', label: 'English' },
        { code: 'ar', label: 'العربية' },
        { code: 'tr', label: 'Türkçe' }
    ];

    const inputstyle = "py-3 px-5 block w-full border-gray-499 rounded text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none";

    const save = async () => {
        if (!data.name[activeLang] || data.name[activeLang].trim() === '') {
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: 'لطفاً نام را وارد کنید'
            });
            return;
        }

        setSaving(true);
        try {
            // Generate URL from name if not provided
            if (!data.url[activeLang] || data.url[activeLang].trim() === '') {
                data.url[activeLang] = changeUrl(data.name[activeLang]);
            }

            let res = await axios({
                method: 'post',
                data: data,
                url: config.url + '/v1/dashboard/campaignproducts',
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            Swal.fire({
                icon: 'success',
                title: t('Success'),
                text: 'محصول کمپین با موفقیت ایجاد شد',
                timer: 1500,
                showConfirmButton: false
            });

            // Save the created product ID for image upload
            const productId = res.data.message._id || res.data.message.id;
            setCreatedProductId(productId);

            setData({
                name: { ku: '', fa: '', en: '', ar: '', tr: '' },
                description: { ku: '', fa: '', en: '', ar: '', tr: '' },
                url: { ku: '', fa: '', en: '', ar: '', tr: '' },
                mainprice: null
            });
            reloaditem();
        } catch (error: any) {
            let errorMessage = 'خطا در ایجاد محصول کمپین';
            if (error.response?.data?.message) {
                const msg = error.response.data.message;
                if (typeof msg === 'string') {
                    errorMessage = msg;
                } else if (typeof msg === 'object' && msg.message) {
                    errorMessage = typeof msg.message === 'string' ? msg.message : String(msg.message);
                }
            }
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: errorMessage,
            });
        } finally {
            setSaving(false);
        }
    }

    return (
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-4" dir="rtl">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">افزودن محصول کمپین جدید</h3>

            {/* Language Selector */}
            <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                    زبان / Language
                </label>
                <div className="flex gap-2 flex-wrap">
                    {languages.map((lang) => (
                        <button
                            key={lang.code}
                            type="button"
                            onClick={() => setActiveLang(lang.code)}
                            className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${activeLang === lang.code
                                ? 'bg-blue-600 text-white'
                                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                                }`}
                        >
                            {lang.label}
                        </button>
                    ))}
                </div>
            </div>

            <form className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        نام ({languages.find(l => l.code === activeLang)?.label}) <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        value={data.name[activeLang] || ''}
                        onChange={(e) => {
                            const nameValue = e.target.value;
                            const slugValue = changeUrl(nameValue);
                            setData({
                                ...data,
                                name: { ...data.name, [activeLang]: nameValue },
                                url: { ...data.url, [activeLang]: slugValue }
                            });
                        }}
                        className={inputstyle}
                        placeholder="نام محصول کمپین"
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        توضیحات ({languages.find(l => l.code === activeLang)?.label})
                    </label>
                    <textarea
                        value={data.description[activeLang] || ''}
                        onChange={(e) => setData({
                            ...data,
                            description: { ...data.description, [activeLang]: e.target.value }
                        })}
                        className={inputstyle}
                        placeholder="توضیحات محصول کمپین (اختیاری)"
                        rows={3}
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        URL ({languages.find(l => l.code === activeLang)?.label})
                    </label>
                    <input
                        type="text"
                        value={data.url[activeLang] || ''}
                        onChange={(e) => setData({
                            ...data,
                            url: { ...data.url, [activeLang]: e.target.value }
                        })}
                        className={inputstyle}
                        placeholder="campaign-product-url"
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        قیمت (یورو) / Price (EUR)
                    </label>
                    <input
                        type="number"
                        dir="ltr"
                        value={data.mainprice || ''}
                        onChange={(e) => setData({
                            ...data,
                            mainprice: e.target.value ? parseFloat(e.target.value) : null
                        })}
                        className={`${inputstyle} text-left`}
                        placeholder="0.00"
                        step="0.01"
                        min="0"
                    />
                </div>

                {createdProductId && (
                    <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            آپلود تصویر محصول کمپین
                        </label>
                        <ImageUploader id={createdProductId} component="campaignproduct"></ImageUploader>
                        <button
                            type="button"
                            onClick={() => {
                                setCreatedProductId(null);
                                reloaditem();
                            }}
                            className="mt-3 w-full px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700"
                        >
                            ایجاد محصول جدید
                        </button>
                    </div>
                )}

                <button
                    type="button"
                    onClick={save}
                    disabled={saving}
                    className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    {saving ? 'در حال ذخیره...' : 'ذخیره'}
                </button>
            </form>
        </div>
    );
}

function ListofCampaignProducts() {
    const { t } = useTranslation();
    let cookie = getCookies();
    const [list, setList] = useState<any>(null);
    const [error, setError] = useState<any>(null);
    const [key, setKey] = useState<any>(1);

    const getalldata = async (mypage: any = 1) => {
        setError(null);
        try {
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/campaignproducts?page=' + mypage,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            setList(res.data.message);
        } catch (error: any) {
            setError(error.response?.data?.message?.errors || 'خطا در بارگذاری داده‌ها');
        }
    }

    const deleted = async (id: any) => {
        Swal.fire({
            title: t("Are you sure?"),
            text: t("Delete this Campaign Product!"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t("Yes, delete it!")
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await axios({
                        method: 'delete',
                        url: config.url + '/v1/dashboard/campaignproducts/' + id,
                        headers: {
                            Authorization: 'Bearer ' + cookie['token'],
                        }
                    });
                    Swal.fire({
                        icon: 'success',
                        title: t('Deleted!'),
                        text: 'محصول کمپین حذف شد',
                        timer: 1500,
                        showConfirmButton: false
                    });
                    getalldata();
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: t('Error'),
                        text: 'خطا در حذف محصول کمپین'
                    });
                }
            }
        });
    }

    useEffect(() => {
        getalldata();
    }, []);

    // Helper function to get display name
    const getDisplayName = (name: any): string => {
        if (!name) return '';
        if (typeof name === 'string') return name;
        if (typeof name === 'object') {
            return name.en || name.fa || name.ku || name.ar || name.tr || '';
        }
        return String(name);
    };

    return (
        <div>
            <div className="flex flex-col text-right">
                <div className="-m-1.5 overflow-x-auto">
                    <div className="p-1.5 min-w-full inline-block align-middle">
                        <div className="overflow-hidden">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead>
                                    <tr>
                                        <th scope="col" className="px-6 py-3 text-xs font-medium text-gray-500 uppercase">
                                            {t('Name')}
                                        </th>
                                        <th scope="col" className="px-6 py-3 text-xs font-medium text-gray-500 uppercase">
                                            {t('Description')}
                                        </th>
                                        <th scope="col" className="px-6 py-3 text-xs font-medium text-gray-500 uppercase">
                                            {t('Price')}
                                        </th>
                                        <th scope="col" className="px-6 py-3 text-xs font-medium text-gray-500 uppercase">
                                            {t('Action')}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {list != null && list.docs && list.docs.length > 0 ? (
                                        list.docs.map((item: any) => {
                                            const displayName = getDisplayName(item.name);
                                            const displayDescription = getDisplayName(item.description);
                                            return (
                                                <tr key={item.id || item._id} className="odd:bg-white even:bg-gray-100 hover:bg-gray-100">
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                                                        {displayName}
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600 max-w-xs truncate">
                                                        {displayDescription || '-'}
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-green-600 font-medium">
                                                        {item.mainprice ? `€${item.mainprice}` : '-'}
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium flex gap-2">
                                                        <a
                                                            href={`/dashboard/Campaign/Products/${item.id || item._id}`}
                                                            type="button"
                                                            className="inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent text-blue-600 hover:text-blue-800 focus:outline-none focus:text-blue-800 disabled:opacity-50 disabled:pointer-events-none"
                                                        >
                                                            <img src="/icons/editgreen.svg" width={20} alt="Edit" />
                                                        </a>
                                                        <button
                                                            onClick={(e) => { deleted(item.id || item._id) }}
                                                            type="button"
                                                            className="inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent text-blue-600 hover:text-blue-800 focus:outline-none focus:text-blue-800 disabled:opacity-50 disabled:pointer-events-none"
                                                        >
                                                            <img src="/icons/delred.svg" width={20} alt="Del" />
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={4} className="px-6 py-4 text-center text-sm text-gray-500">
                                                هیچ محصول کمپینی یافت نشد
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        {list != null && list.totalPages > 1 && (
                            <div className="mt-4">
                                <nav className="flex items-center -space-x-px" aria-label="Pagination">
                                    {list.prevPage != null && (
                                        <button
                                            onClick={(e) => { getalldata(list.page - 1); }}
                                            type="button"
                                            className="min-h-[38px] min-w-[38px] py-2 px-2.5 inline-flex justify-center items-center gap-x-1.5 text-sm first:rounded-s-lg last:rounded-e-lg border border-gray-200 text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none"
                                            aria-label="Previous"
                                        >
                                            <svg className="shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="m15 18-6-6 6-6"></path>
                                            </svg>
                                            <span className="hidden sm:block">{t('Previous')}</span>
                                        </button>
                                    )}
                                    {Array.from({ length: list.totalPages }, (_, index) => index + 1).map((item) => {
                                        return (
                                            list.page == item ? (
                                                <button
                                                    key={item}
                                                    type="button"
                                                    className="min-h-[38px] min-w-[38px] flex justify-center items-center bg-gray-200 text-gray-800 border border-gray-200 py-2 px-3 text-sm first:rounded-s-lg last:rounded-e-lg focus:outline-none focus:bg-gray-300 disabled:opacity-50 disabled:pointer-events-none"
                                                    aria-current="page"
                                                >
                                                    {item}
                                                </button>
                                            ) : (
                                                <button
                                                    key={item}
                                                    onClick={(e) => { getalldata(item); }}
                                                    type="button"
                                                    className="min-h-[38px] min-w-[38px] flex justify-center items-center bg-white text-gray-800 border border-gray-200 py-2 px-3 text-sm first:rounded-s-lg last:rounded-e-lg hover:bg-gray-100 focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none"
                                                >
                                                    {item}
                                                </button>
                                            )
                                        );
                                    })}
                                    {list.nextPage != null && (
                                        <button
                                            onClick={(e) => { getalldata(list.page + 1); }}
                                            type="button"
                                            className="min-h-[38px] min-w-[38px] py-2 px-2.5 inline-flex justify-center items-center gap-x-1.5 text-sm first:rounded-s-lg last:rounded-e-lg border border-gray-200 text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none"
                                            aria-label="Next"
                                        >
                                            <span className="hidden sm:block">{t('Next')}</span>
                                            <svg className="shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="m9 18 6-6-6-6"></path>
                                            </svg>
                                        </button>
                                    )}
                                </nav>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
